import React from "react";
import { Container } from "react-bootstrap";
import UnderlinedHeader from "../../../molecules/UnderlinedHeader/UnderlinedHeader";
import useSmallNav from "../../../../hooks/useSmallNav";
import InfoHero from "../../../molecules/info/InfoHero/InfoHero";
import InfoGrid from "../../../atoms/info/InfoGrid/InfoGrid";
import InfoCard from "../../../molecules/info/InfoCard/InfoCard";
import santa from "./../../../../assets/info/santa-fe-hero.jpg";
import InfoFooter from "../../../organisms/InfoFooter/InfoFooter";
import { popularVehicle } from "../../../../vars/popularVehicles";

const SantaFe = () => {
  useSmallNav("Hyundai Santa Fe");

  return (
    <section className={"popular"}>
      <Container>
        <UnderlinedHeader text={"Hyundai Santa Fe"} bolder />
        <InfoHero image={santa} />
        <InfoGrid>
          <div>
            <UnderlinedHeader
              text={
                "CZY JESTEŚ WŁAŚCICIELEM HYUNDAI SANTA FE? SZUKASZ CZĘŚCI ZAWIESZENIA LUB CHCESZ USPRAWNIĆ ZAWIESZENIE?"
              }
              soft
            />
            <UnderlinedHeader
              text={"JEŚLI TAK TO JESTEŚ W WŁAŚCIWE MIEJSCU."}
              soft
            />
            <p>
              Czy zawieszenie samopoziomujące w Santa Fe nie sprawdziło się? I
              właśnie otrzymałeś wycenę za jego wymianę? Jeśli tak, to właśnie
              znalazłeś optymalne rozwiązanie, które pomoże rozwiązać problem
              zawieszenia w Sante Fe.
            </p>
            <p>
              Zestaw Pedders jest używany do zastąpienia oryginalnego
              zawieszenia samopoziomującego. I jest gotowy do szybkiego montażu
              jako gotowy zestaw zamienny. Nie są wymagane żadne modyfikacje
              pojazdu oraz nie są wymagane żadne dodatkowe części.
            </p>
            <UnderlinedHeader
              text={"„Czy mój pojazd powróci do pierwotnej wysokości?”"}
              soft
            />
            <p>
              Tak, zdecydowanie! Istnieje wiele przykładów Santa Fe, które po
              wymianie samopoziomujących amortyzatorów na konwencjonalne, stały
              zbyt nisko. Dzieje się tak, ponieważ oryginalna sprężyna jest zbyt
              słaba, aby wytrzymać cały ciężar samochodu, i pomaga jej w tym
              amortyzator samopoziomujący.
            </p>
            <p>
              Zawieszenie Pedders rozwiązuje ten problem, dostarczając
              specjalnie do tego celu dopasowany zestaw amortyzatorów i sprężyn.
              Możesz być przekonany, że pojazd będzie miał odpowiednią wysokość,
              a Twoje kłopotliwe i drogie amortyzatory samopoziomujące przejdą
              do historii.
            </p>
            <p>
              Należy pamiętać, że nasze pomiary wysokości pojazdu są oparte na
              16-calowych kołach. Nie oznacza to, że będzie pasować tylko do
              samochodów z 16-calowymi kołami. Zestaw BĘDZIE pasował niezależnie
              od rozmiaru koła.
            </p>
          </div>
          <div>
            {popularVehicle
              .find((e) => e.make === "Hyundai")
              .models.find((e) => e.display === "Santa Fe")
              .popular.map((item) => (
                <InfoCard
                  key={item.text}
                  name={item.text}
                  to={item.link}
                  photo={item.photo}
                />
              ))}
            <iframe
              title="Hyundai Santa Fe"
              width="100%"
              height="315"
              src="https://www.youtube.com/embed/9PvSqeTDVxk"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              title="Hyundai Santa Fe"
              width="100%"
              height="315"
              src="https://www.youtube.com/embed/KnT6sI4QaYk"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </InfoGrid>
        <InfoFooter make="Hyundai" model="Santa Fe" />
      </Container>
    </section>
  );
};

export default SantaFe;
